import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ap_link = _resolveComponent("ap-link")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ap_link, {
      revalStatus: $options.revalidationStatus,
      href: "https://apdirect.airproducts.com/Invoice/AcctStmt"
    }, {
      default: _withCtx(() => [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pay-online-icon" }, null, -1)),
        _createElementVNode("div", {
          class: "pay-online-text",
          innerHTML: _ctx.$t('ml_107027', 'X-Pay Online')
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["revalStatus"])
  ]))
}